export default "__VITE_ASSET__DWaRO4ez__"